
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'AppSubscriptionAlert'
})
export default class AppSubscriptionAlert extends Vue {
  showModal = true;

  navigateToSubscription() {
    window.location.href = '/subscription';
  }

  closeModal() {
    this.showModal = false;
  }
}
